'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _get2 = require('lodash/get');

var _get3 = _interopRequireDefault(_get2);

exports.loadProjectStatsViewers = loadProjectStatsViewers;
exports.addStatsViewer = addStatsViewer;
exports.deleteStatsViewer = deleteStatsViewer;
exports.loadActivityStats = loadActivityStats;
exports.loadPlayStats = loadPlayStats;
exports.loadPopularityStats = loadPopularityStats;
exports.loadCoverageStats = loadCoverageStats;
exports.loadGeographyStats = loadGeographyStats;
exports.loadDevicesStats = loadDevicesStats;
exports.loadRecipientDetailedStats = loadRecipientDetailedStats;
exports.loadRecipientOverallStats = loadRecipientOverallStats;
exports.loadTracksDetailsStats = loadTracksDetailsStats;
exports.isAvailableProjectsLoadTime = isAvailableProjectsLoadTime;
exports.loadAvailableProjects = loadAvailableProjects;
exports.isMyProjectsLoadTime = isMyProjectsLoadTime;
exports.loadMyProjects = loadMyProjects;
exports.projectsReorder = projectsReorder;
exports.recipientsReorder = recipientsReorder;
exports.recipientProjectsReorder = recipientProjectsReorder;
exports.coverageRecipientsReorder = coverageRecipientsReorder;
exports.filterProjects = filterProjects;
exports.filterRecipients = filterRecipients;
exports.setProjectsTab = setProjectsTab;
exports.setPeriodName = setPeriodName;
exports.setReportDates = setReportDates;
exports.setPeriod = setPeriod;
exports.setProjectId = setProjectId;
exports.setRecipientId = setRecipientId;
exports.isProjectInfoLoadTime = isProjectInfoLoadTime;
exports.loadProjectInfo = loadProjectInfo;
exports.isRecipientsLoadTime = isRecipientsLoadTime;
exports.loadRecipients = loadRecipients;
exports.getLink = getLink;
exports.sendReminders = sendReminders;
exports.setProjectsListPage = setProjectsListPage;

var _loadReducer = require('../loadReducer');

var _loadReducer2 = _interopRequireDefault(_loadReducer);

var _StatisticsReducer = require('../reducers/StatisticsReducer');

var _StatisticsReducer2 = _interopRequireDefault(_StatisticsReducer);

var _statistics = require('../constants/statistics');

var _statistics2 = _interopRequireDefault(_statistics);

var _statistics3 = require('helpers/statistics');

var _loadReducer3 = require('redux/loadReducer');

var _ApiClient = require('helpers/ApiClient');

var _projects = require('helpers/projects');

var _datetime = require('helpers/datetime');

var _moment = require('moment');

var _moment2 = _interopRequireDefault(_moment);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var requestCacheTime = 10 * 60 * 1000; // msec

/* Statistics redux reducer and action creators */

var loadReducer = (0, _loadReducer2.default)(_statistics.moduleName, {
  statsViewers: {},
  availableProjects: { action: 'load', init: [] },
  myProjects: {
    action: 'load',
    init: { newsletters: [], sharespace: [], audio: [], video: [] },
    fields: {
      newsletters: 'listNewsletters',
      sharespace: 'listOfMasterProject',
      audio: 'listOfAudioProjects',
      video: 'listOfVideoProjects'
    }
  },
  addStatsViewer: {},
  deleteStatsViewer: { loaderKeys: ['projectId', 'email'] },
  activityStats: { action: 'load' },
  playStats: { action: 'load' },
  popularityStats: { action: 'load' },
  coverageStats: { action: 'load' },
  geographyStats: { action: 'load' },
  devicesStats: { action: 'load' },
  recipientDetailedStats: { action: 'load' },
  recipientOverallStats: { action: 'load' },
  tracksDetailsStats: { action: 'load' },
  projectInfo: { action: 'load' },
  recipients: { action: 'load', field: 'usersList' },
  getLink: { loaderKeys: ['projectId'] }, //TODO: change
  sendReminders: {}
});

var initialState = (0, _extends3.default)({}, loadReducer.initialState, {
  projectsOrder: {
    id: 'desc',
    fullTitle: 'asc',
    owName: 'asc',
    statusText: 'asc',
    iRef: 'asc'
  },
  projectsActiveOrder: 'id',
  recipientsOrder: {
    id: 'desc',
    fullName: 'asc',
    email: 'asc'
  },
  recipientsActiveOrder: 'email',
  coverageRecipientsOrder: {
    recipientId: 'desc',
    fullName: 'asc',
    email: 'asc',
    downloaded: 'asc',
    recepEd: 'asc'
  },
  coverageRecipientsActiveOrder: 'fullName',
  recipientProjectsOrder: {
    id: 'desc',
    fullTitle: 'asc',
    played: 'asc',
    downloaded: 'asc',
    expiryDate: 'asc'
  },
  recipientProjectsActiveOrder: 'id',
  projectsKw: '',
  recipientsKw: '',
  periodName: null,
  myProjectsListPage: 1
});

exports.default = new _StatisticsReducer2.default({
  apiConstants: loadReducer.constants,
  mainReducer: loadReducer.reducer,
  constants: _statistics2.default,
  initialState: initialState
}).reducer;
var constantsByKey = loadReducer.constantsByKey;
function loadProjectStatsViewers(_ref) {
  var projectId = _ref.projectId;

  var data = { projectId: projectId };
  return (0, _extends3.default)({
    types: constantsByKey.statsViewers,
    promise: function promise(client) {
      return client.post('stats_wa/getStatsViewersForProject', { data: data });
    }
  }, data);
}

function addStatsViewer(_ref2) {
  var projectId = _ref2.projectId,
      email = _ref2.email,
      name = _ref2.name,
      surname = _ref2.surname;

  var data = { email: email, name: name, surname: surname, projectId: projectId };
  return (0, _extends3.default)({
    types: constantsByKey.addStatsViewer,
    promise: function promise(client) {
      return client.post('stats_wa/addUserToProjectStats', { data: data });
    }
  }, data);
}

function deleteStatsViewer(_ref3) {
  var projectId = _ref3.projectId,
      email = _ref3.email;

  var data = { projectId: projectId, email: email };
  return (0, _extends3.default)({
    types: constantsByKey.deleteStatsViewer,
    promise: function promise(client) {
      return client.post('stats_wa/removeUserFromProjectStats', { data: data });
    }
  }, data);
}

function getReportDates(_ref4) {
  var startDate = _ref4.startDate,
      endDate = _ref4.endDate,
      _ref4$isUnix = _ref4.isUnix,
      isUnix = _ref4$isUnix === undefined ? false : _ref4$isUnix;

  return function (dispatch, getState) {
    var sqlStartDate = startDate || getState().statistics.startDate;
    var sqlEndDate = endDate || getState().statistics.endDate;
    return {
      startDate: isUnix ? (0, _datetime.formatDateToUnix)(sqlStartDate) : sqlStartDate,
      endDate: isUnix ? (0, _datetime.formatDateToUnix)(sqlEndDate) : sqlEndDate
    };
  };
}

function loadActivityStats(_ref5) {
  var projectId = _ref5.projectId,
      startDate = _ref5.startDate,
      endDate = _ref5.endDate;

  return function (dispatch) {
    var data = (0, _extends3.default)({ projectId: projectId }, dispatch(getReportDates({ startDate: startDate, endDate: endDate })));
    return dispatch({
      types: constantsByKey.activityStats,
      promise: function promise(client) {
        return client.post('stats_wa/getActivity', { data: data });
      },
      projectId: projectId,
      startDate: startDate,
      endDate: endDate,
      abortable: true
    });
  };
}

function loadPlayStats(_ref6) {
  var projectId = _ref6.projectId,
      startDate = _ref6.startDate,
      endDate = _ref6.endDate;

  return function (dispatch) {
    var data = (0, _extends3.default)({ projectId: projectId }, dispatch(getReportDates({ startDate: startDate, endDate: endDate })));
    return dispatch({
      types: constantsByKey.playStats,
      promise: function promise(client) {
        return client.post('stats_wa/getPlayStats', { data: data });
      },
      projectId: projectId,
      startDate: startDate,
      endDate: endDate,
      abortable: true
    });
  };
}

function loadPopularityStats(_ref7) {
  var projectId = _ref7.projectId,
      recipientId = _ref7.recipientId,
      startDate = _ref7.startDate,
      endDate = _ref7.endDate;

  return function (dispatch) {
    var data = (0, _extends3.default)({ projectId: projectId, recipientId: recipientId }, dispatch(getReportDates({ startDate: startDate, endDate: endDate })));
    return dispatch({
      types: constantsByKey.popularityStats,
      promise: function promise(client) {
        return client.post('stats_wa/getPopularity', { data: data });
      },
      projectId: projectId,
      recipientId: recipientId,
      startDate: startDate,
      endDate: endDate,
      abortable: true
    });
  };
}

function loadCoverageStats(_ref8) {
  var projectId = _ref8.projectId,
      startDate = _ref8.startDate,
      endDate = _ref8.endDate;

  return function (dispatch) {
    var data = (0, _extends3.default)({ projectId: projectId }, dispatch(getReportDates({ startDate: startDate, endDate: endDate })));
    return dispatch({
      types: constantsByKey.coverageStats,
      promise: function promise(client) {
        return client.post('stats_wa/getCoverage', { data: data });
      },
      projectId: projectId,
      startDate: startDate,
      endDate: endDate,
      abortable: true
    });
  };
}

function loadGeographyStats(_ref9) {
  var projectId = _ref9.projectId,
      startDate = _ref9.startDate,
      endDate = _ref9.endDate;

  return function (dispatch) {
    var data = (0, _extends3.default)({ projectId: projectId }, dispatch(getReportDates({ startDate: startDate, endDate: endDate })));
    return dispatch({
      types: constantsByKey.geographyStats,
      promise: function promise(client) {
        return client.post('stats_wa/getGeography', { data: data });
      },
      projectId: projectId,
      startDate: startDate,
      endDate: endDate,
      abortable: true
    });
  };
}

function loadDevicesStats() {
  var _ref10 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
      projectId = _ref10.projectId,
      startDate = _ref10.startDate,
      endDate = _ref10.endDate;

  return function (dispatch) {
    var data = (0, _extends3.default)({ projectId: projectId }, dispatch(getReportDates({ startDate: startDate, endDate: endDate })));
    return dispatch({
      types: constantsByKey.devicesStats,
      promise: function promise(client) {
        return client.post('stats_wa/getDevices', { data: data });
      },
      projectId: projectId,
      startDate: startDate,
      endDate: endDate,
      abortable: true
    });
  };
}

function loadRecipientDetailedStats() {
  var _ref11 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
      projectId = _ref11.projectId,
      recipientId = _ref11.recipientId,
      startDate = _ref11.startDate,
      endDate = _ref11.endDate;

  return function (dispatch) {
    var data = (0, _extends3.default)({ projectId: projectId, recipientId: recipientId }, dispatch(getReportDates({ startDate: startDate, endDate: endDate })));
    return dispatch({
      types: constantsByKey.recipientDetailedStats,
      promise: function promise(client) {
        return client.post('stats_wa/getRecipientDetailedActivity', { data: data });
      },
      projectId: projectId,
      startDate: startDate,
      endDate: endDate,
      abortable: true
    });
  };
}

function loadRecipientOverallStats() {
  var _ref12 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
      userId = _ref12.userId,
      startDate = _ref12.startDate,
      endDate = _ref12.endDate;

  return function (dispatch) {
    var data = (0, _extends3.default)({ userId: userId }, dispatch(getReportDates({ startDate: startDate, endDate: endDate })));
    return dispatch({
      types: constantsByKey.recipientOverallStats,
      promise: function promise(client) {
        return client.post('stats_wa/getRecipientOverallActivity', { data: data });
      },
      userId: userId,
      startDate: startDate,
      endDate: endDate,
      abortable: true
    });
  };
}

function loadTracksDetailsStats() {
  var _ref13 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
      projectId = _ref13.projectId,
      recipientId = _ref13.recipientId,
      startDate = _ref13.startDate,
      endDate = _ref13.endDate;

  return function (dispatch) {
    var data = (0, _extends3.default)({ projectId: projectId, recipientId: recipientId }, dispatch(getReportDates({ startDate: startDate, endDate: endDate })));
    return dispatch({
      types: constantsByKey.tracksDetailsStats,
      promise: function promise(client) {
        return client.post('stats_wa/getTrackDetails', { data: data });
      },
      projectId: projectId,
      startDate: startDate,
      endDate: endDate,
      abortable: true
    });
  };
}

function isAvailableProjectsLoadTime() {
  var _ref14 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
      _ref14$useCache = _ref14.useCache,
      useCache = _ref14$useCache === undefined ? true : _ref14$useCache,
      _ref14$cacheTime = _ref14.cacheTime,
      cacheTime = _ref14$cacheTime === undefined ? requestCacheTime : _ref14$cacheTime;

  return function (dispatch, getState) {
    return (0, _loadReducer3.isLoadTime)({ useCache: useCache, cacheTime: cacheTime, key: 'availableProjects', state: getState().statistics });
  };
}

function loadAvailableProjects() {
  var _ref15 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
      useCache = _ref15.useCache,
      cacheTime = _ref15.cacheTime;

  return function (dispatch) {
    var needLoad = dispatch(isAvailableProjectsLoadTime({ useCache: useCache, cacheTime: cacheTime }));
    if (needLoad) {
      return dispatch({
        types: constantsByKey.availableProjects,
        promise: function promise(client) {
          return client.post('/Stats_wa/getMyStatsProjectList');
        }
      });
    }
    return _ApiClient.noopResponse;
  };
}

function isMyProjectsLoadTime() {
  var _ref16 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
      _ref16$useCache = _ref16.useCache,
      useCache = _ref16$useCache === undefined ? true : _ref16$useCache,
      _ref16$cacheTime = _ref16.cacheTime,
      cacheTime = _ref16$cacheTime === undefined ? requestCacheTime : _ref16$cacheTime;

  return function (dispatch, getState) {
    return (0, _loadReducer3.isLoadTime)({ useCache: useCache, cacheTime: cacheTime, key: 'myProjects', state: getState().statistics });
  };
}

function loadMyProjects() {
  var _ref17 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
      useCache = _ref17.useCache,
      cacheTime = _ref17.cacheTime;

  return function (dispatch) {
    var needLoad = dispatch(isMyProjectsLoadTime({ useCache: useCache, cacheTime: cacheTime }));
    if (needLoad) {
      return dispatch({
        types: constantsByKey.myProjects,
        promise: function promise(client) {
          var result = client.post('project_wa/getList');
          result.promise.then(_projects.transformProjectsResponse);
          return result;
        }
      });
    }
    return _ApiClient.noopResponse;
  };
}

function projectsReorder(name) {
  return {
    type: _statistics2.default.PROJECTS_REORDER,
    name: name
  };
}

function recipientsReorder(name) {
  return {
    type: _statistics2.default.RECIPIENTS_REORDER,
    name: name
  };
}

function recipientProjectsReorder(name) {
  return {
    type: _statistics2.default.RECIPIENT_PROJECTS_REORDER,
    name: name
  };
}

function coverageRecipientsReorder(name) {
  return {
    type: _statistics2.default.COVERAGE_RECIPIENTS_REORDER,
    name: name
  };
}

function filterProjects() {
  var kw = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';

  return {
    type: _statistics2.default.PROJECTS_FILTER,
    kw: kw
  };
}

function filterRecipients() {
  var kw = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';

  return {
    type: _statistics2.default.RECIPIENTS_FILTER,
    kw: kw
  };
}

function setProjectsTab() {
  var tab = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : _statistics3.projectTabs.my;

  return {
    type: _statistics2.default.SET_PROJECTS_TAB,
    tab: tab
  };
}

function setPeriodName(_ref18) {
  var periodName = _ref18.periodName;

  return {
    type: _statistics2.default.SET_PERIOD_NAME,
    periodName: periodName
  };
}

function setReportDates(_ref19) {
  var startDate = _ref19.startDate,
      endDate = _ref19.endDate;

  return {
    type: _statistics2.default.SET_REPORT_DATES,
    startDate: startDate,
    endDate: endDate
  };
}

function setPeriod(_ref20) {
  var periodName = _ref20.periodName,
      _ref20$periodValue = _ref20.periodValue,
      periodValue = _ref20$periodValue === undefined ? 1 : _ref20$periodValue;

  return function (dispatch) {
    var startDate = (0, _datetime.formatDateToSql)((0, _moment2.default)().subtract(periodValue, periodName));
    var endDate = (0, _datetime.formatDateToSql)(Date.now());
    dispatch(setReportDates({ startDate: startDate, endDate: endDate }));
    dispatch(setPeriodName({ periodName: periodName }));
  };
}

function setProjectId(_ref21) {
  var projectId = _ref21.projectId;

  return {
    type: _statistics2.default.SET_PROJECT_ID,
    projectId: projectId
  };
}

function setRecipientId(_ref22) {
  var recipientId = _ref22.recipientId;

  return {
    type: _statistics2.default.SET_RECIPIENT_ID,
    recipientId: recipientId
  };
}

function isProjectInfoLoadTime() {
  var _ref23 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
      projectId = _ref23.projectId,
      _ref23$useCache = _ref23.useCache,
      useCache = _ref23$useCache === undefined ? true : _ref23$useCache,
      _ref23$cacheTime = _ref23.cacheTime,
      cacheTime = _ref23$cacheTime === undefined ? requestCacheTime : _ref23$cacheTime;

  return function (dispatch, getState) {
    if (projectId !== (0, _get3.default)(getState().statistics, 'projectInfoData.projectId')) {
      return true;
    }
    return (0, _loadReducer3.isLoadTime)({ useCache: useCache, cacheTime: cacheTime, key: 'projectInfo', state: getState().statistics });
  };
}

function loadProjectInfo(_ref24) {
  var projectId = _ref24.projectId;

  return function (dispatch) {
    var needLoad = dispatch(isProjectInfoLoadTime({ projectId: projectId, cacheTime: Infinity }));
    if (needLoad) {
      return dispatch({
        types: constantsByKey.projectInfo,
        promise: function promise(client) {
          return client.post('stats_wa/getSimpleProject', { data: { projectId: projectId } });
        },
        projectId: Number(projectId)
      });
    }
    return _ApiClient.noopResponse;
  };
}

function isRecipientsLoadTime() {
  var _ref25 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
      _ref25$useCache = _ref25.useCache,
      useCache = _ref25$useCache === undefined ? true : _ref25$useCache,
      _ref25$cacheTime = _ref25.cacheTime,
      cacheTime = _ref25$cacheTime === undefined ? requestCacheTime : _ref25$cacheTime;

  return function (dispatch, getState) {
    return (0, _loadReducer3.isLoadTime)({ useCache: useCache, cacheTime: cacheTime, key: 'recipients', state: getState().statistics });
  };
}

function loadRecipients() {
  return function (dispatch) {
    var needLoad = dispatch(isRecipientsLoadTime());
    if (needLoad) {
      return dispatch({
        types: constantsByKey.recipients,
        promise: function promise(client) {
          return client.post('stats_wa/getProjectsRecipients');
        }
      });
    }
    return _ApiClient.noopResponse;
  };
}

function getLink() {
  var _ref26 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
      _ref26$projectId = _ref26.projectId,
      projectId = _ref26$projectId === undefined ? 2286386 : _ref26$projectId;

  //TODO: remove
  var data = { projectId: projectId };
  return {
    types: constantsByKey.getLink,
    promise: function promise(client) {
      return client.post('/project_wa/downloadRecipientLinks', { data: data });
    },
    projectId: projectId,
    abortable: true
  };
}

function sendReminders(_ref27) {
  var projectId = _ref27.projectId,
      sendType = _ref27.sendType;

  var data = { projectId: projectId, sendType: sendType };
  return (0, _extends3.default)({
    types: constantsByKey.sendReminders,
    promise: function promise(client) {
      return client.post('/stats_wa/sendReminders', { data: data });
    }
  }, data);
}

function setProjectsListPage(_ref28) {
  var page = _ref28.page;

  return {
    type: _statistics2.default.SET_PROJECTS_LIST_PAGE,
    page: page
  };
}


//////////////////
// WEBPACK FOOTER
// ./src/redux/modules/statistics.js
// module id = 57
// module chunks = 1